import { BASE_CURRENCY } from "@loan-crm/shared"

function resolveCurrency(currency?: string | null) {
  if (typeof currency !== "string") {
    return BASE_CURRENCY
  }

  const normalized = currency.trim().toUpperCase()
  if (!/^[A-Z]{3}$/.test(normalized)) {
    return BASE_CURRENCY
  }

  return normalized
}

export function formatCurrency(amount: number, currency?: string | null) {
  return new Intl.NumberFormat("en-KE", {
    style: "currency",
    currency: resolveCurrency(currency),
    minimumFractionDigits: 2,
  }).format(amount / 100)
}

export function formatDateTime(value?: string | null) {
  if (!value) {
    return "-"
  }

  return new Intl.DateTimeFormat("en-KE", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value))
}

export function formatDate(value?: string | null) {
  if (!value) {
    return "-"
  }

  return new Intl.DateTimeFormat("en-KE", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(value))
}

export function formatDurationSeconds(value?: number | null) {
  if (!value || value <= 0) {
    return "-"
  }

  const minutes = Math.floor(value / 60)
  const seconds = value % 60

  if (minutes === 0) {
    return `${seconds}s`
  }

  return `${minutes}m ${seconds}s`
}

export function formatEnumLabel(value?: string | null) {
  if (!value) {
    return "-"
  }

  if (value === "S1") {
    return "S-1"
  }

  return value
    .toLowerCase()
    .split("_")
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(" ")
}
